import { createGridLayout, createGridItem } from "../../../../store/global/gridlayout";

export const billingSettingsGrid = createGridLayout({
  layout: [
    createGridItem({
      x: 0,
      y: 0,
      w: 30,
      h: 40,
      i: "invoice"
    }),
    createGridItem({
      x: 30,
      y: 0,
      w: 30,
      h: 33,
      i: "support_issue"
    }),
    createGridItem({
      x: 30,
      y: 33,
      w: 30,
      h: 7,
      i: "Billing Info"
    })
  ]
});
